import { gql } from "@apollo/client";

/**
 * An event as the invitation rules suggest it. Inlined rather than a fragment:
 * the admin's Apollo cache runs without __typename, and a type-conditioned
 * fragment silently drops its fields.
 */
const EVENT_FIELDS = `
  eventId
  title
  link
  programme
  typeLabel
  startDate
  when
  clock
  hostName
  why
  afterPass
  outsideHerDay
  levelMismatch
`;

/** Members from the new signup flow — maps to newMembers.resolver.ts. */
export const ADMIN_NEW_MEMBERS = gql`
  query adminNewMembers($days: Int!) {
    adminNewMembers(days: $days) {
      days
      total
      generatedAt
      members {
        userId
        name
        firstName
        email
        status
        statusLabel
        signedUpAt
        ageDays
        timezone
        selectedTimezone
        speakingLevel
        guestTokensLeft
        guestDaysLeft
        guestPassLive
        eventsAttended
        acceptedUpcoming
        priority
        priorityLabel
        challenge
        challengeLabel
        readiness
        readinessLabel
        firstEventSkipped
        firstEventId
        firstEventTitle
        firstEventStart
        firstEventWhen
        firstEventState
        redFlag
        redFlagLabel
        signupState
        suggestion {
          event {
            ${EVENT_FIELDS}
          }
          invitation {
            ${EVENT_FIELDS}
          }
          byType {
            programme
            label
            tried
            event {
              ${EVENT_FIELDS}
            }
          }
          untried
          holds
          resourceTitle
          resourceLink
        }
        angles {
          key
          label
          message
        }
        defaultAngle
        message
      }
    }
  }
`;
